export default __webpack_public_path__ + "static/media/collections_7.f1ba14c0.jpg";